import React, { PropsWithChildren } from "react";
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const TitledContainerWrapper: React.FC<PropsWithChildren<{ elementId?: string }>> = (props) => {
  const { children, elementId } = props;

  return (
    <Grid id={elementId} item container direction="column" className={cssExports.titledContainer}>
      {children}
    </Grid>
  );
};

export default TitledContainerWrapper;
